import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-set.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.define-property.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
jQuery(document).ready(function ($) {
  var _bindEvents = /*#__PURE__*/new WeakSet();
  var _update_price_html = /*#__PURE__*/new WeakSet();
  var _format_price = /*#__PURE__*/new WeakSet();
  var PriceDisplay = /*#__PURE__*/function () {
    // Mirrors Product_Constant::MAX_PURCHASE_QUANTITY (the input's max attribute).

    function PriceDisplay() {
      _classCallCheck(this, PriceDisplay);
      _classPrivateMethodInitSpec(this, _format_price);
      _classPrivateMethodInitSpec(this, _update_price_html);
      _classPrivateMethodInitSpec(this, _bindEvents);
      _defineProperty(this, "QUANTITY_FIELD", 'input.qty');
      _defineProperty(this, "MAX_QUANTITY", 1000);
      _defineProperty(this, "MAX_TOTAL_PRICE", 10000);
      this.$form = $('.single-product div.product form.cart').first();
      if (!this.$form.length) {
        return;
      }
      this.is_variable = this.$form.hasClass('variations_form');
      _classPrivateMethodGet(this, _bindEvents, _bindEvents2).call(this);

      // Initial state: highlight the reached Staffelpreis row (simple products
      // render the table server-side; variable PDPs get it on show_variation).
      this.update_price_display();
    }
    _createClass(PriceDisplay, [{
      key: "update_price_display",
      value: function update_price_display() {
        var _this$get_tier_unit_p;
        var prices = this.get_base_prices();
        var $container = this.get_price_container();
        if (!prices || !$container.length) {
          return;
        }
        var total_qty = this.get_total_quantity();
        // Staffelpreise: past a threshold the cart charges the tier's unit
        // price, so the displayed total must use it too.
        var unit_price = (_this$get_tier_unit_p = this.get_tier_unit_price(total_qty)) !== null && _this$get_tier_unit_p !== void 0 ? _this$get_tier_unit_p : prices.price;

        // Cap the total at CHF 10'000 with the price actually charged at that
        // quantity. Lowering the quantity can drop below a threshold and raise
        // the unit price again, so repeat until stable (total_qty strictly
        // decreases every pass).
        while (unit_price > 0 && unit_price * total_qty > this.MAX_TOTAL_PRICE) {
          var _this$get_tier_unit_p2;
          var capped = Math.max(1, Math.floor(this.MAX_TOTAL_PRICE / unit_price));
          if (capped >= total_qty) {
            break;
          }
          total_qty = capped;
          unit_price = (_this$get_tier_unit_p2 = this.get_tier_unit_price(total_qty)) !== null && _this$get_tier_unit_p2 !== void 0 ? _this$get_tier_unit_p2 : prices.price;
          this.$form.find(this.QUANTITY_FIELD).val(total_qty);
        }
        var $sale_price = $container.find('ins bdi');
        if ($sale_price.length) {
          _classPrivateMethodGet(this, _update_price_html, _update_price_html2).call(this, unit_price, total_qty, $sale_price);
          if (prices.regular) {
            _classPrivateMethodGet(this, _update_price_html, _update_price_html2).call(this, prices.regular, total_qty, $container.find('del bdi'));
          }
        } else {
          _classPrivateMethodGet(this, _update_price_html, _update_price_html2).call(this, unit_price, total_qty, $container.find('bdi').first());
        }
      }

      // The reached row of the Staffelpreis table (if any): highlight it and
      // return its unit price. Steps are not necessarily descending (customer
      // 0%-overrides), so the deepest reached threshold decides, not the
      // cheapest row - same semantics as the cart.
    }, {
      key: "get_tier_unit_price",
      value: function get_tier_unit_price(quantity) {
        // Simple products render the table before the form, variations inside
        // it (variation template) - scope to the product wrapper to catch both.
        var $rows = this.$form.closest('div.product').find('.discount-tiers tr[data-min-qty]');
        if (!$rows.length) {
          return null;
        }
        var $active = null;
        $rows.each(function (_, row) {
          var $row = $(row);
          if (parseInt($row.attr('data-min-qty'), 10) <= quantity) {
            $active = $row;
          }
        });
        $rows.removeClass('active');
        if (!$active) {
          return null;
        }
        $active.addClass('active');
        var unit_price = parseFloat($active.attr('data-unit-price'));
        return isNaN(unit_price) ? null : unit_price;
      }
    }, {
      key: "get_base_prices",
      value: function get_base_prices() {
        var $base = $('#base-price');
        var price = parseFloat($base.data('base-price'));
        if (!$base.length || isNaN(price)) {
          return null;
        }
        var regular = parseFloat($base.data('regular-price'));
        return {
          price: price,
          regular: isNaN(regular) ? 0 : regular
        };
      }
    }, {
      key: "get_price_container",
      value: function get_price_container() {
        if (this.is_variable) {
          // The theme (variationsPrice.js) copies the variation price into
          // the p.price outside the variation wrap and hides the inner
          // .woocommerce-variation-price via the xts-price-outside class —
          // update the element the customer actually sees.
          if (this.$form.hasClass('xts-price-outside')) {
            var $outside_price = this.$form.parent().find('.price').first();
            if ($outside_price.length) {
              return $outside_price;
            }
          }
          return this.$form.find('.woocommerce-variation-price');
        }
        return $('.single-product div.product .summary .price').first();
      }
    }, {
      key: "get_total_quantity",
      value: function get_total_quantity() {
        var $qty = this.$form.find(this.QUANTITY_FIELD);
        var quantity = parseFloat($qty.val());
        if (isNaN(quantity) || quantity < 1) {
          return 1;
        }
        quantity = Math.min(quantity, this.get_max_quantity($qty));
        if (quantity !== parseFloat($qty.val())) {
          $qty.val(quantity);
        }
        return quantity;
      }

      // Quantities above the input's max (or 1000) are blocked; the CHF 10'000
      // total cap is applied tier-aware in update_price_display().
    }, {
      key: "get_max_quantity",
      value: function get_max_quantity($qty) {
        var attr_max = parseFloat($qty.attr('max'));
        return isNaN(attr_max) ? this.MAX_QUANTITY : Math.max(1, Math.min(attr_max, this.MAX_QUANTITY));
      }
    }]);
    return PriceDisplay;
  }();
  function _bindEvents2() {
    var _this = this;
    // Covers keyboard input, the native spinner and the xts plus/minus
    // buttons (the theme triggers 'change' on the input after clicks).
    this.$form.on('change input', this.QUANTITY_FIELD, function () {
      _this.update_price_display();
    });
    if (this.is_variable) {
      // The variation price (and #base-price) is re-rendered on every
      // attribute selection, so re-apply the quantity then. Deferred so
      // it runs after the theme's variationsPrice handler, which copies
      // the fresh unit price into the outside p.price on the same event.
      this.$form.on('show_variation', function () {
        setTimeout(function () {
          return _this.update_price_display();
        }, 0);
      });
    }
  }
  function _update_price_html2(base_price, total_qty, $price) {
    if (!$price.length) {
      return;
    }
    var currency = $price.find('.woocommerce-Price-currencySymbol').html();
    var price_total = base_price * total_qty;
    if (isNaN(price_total)) {
      price_total = base_price;
    }
    price_total = _classPrivateMethodGet(this, _format_price, _format_price2).call(this, price_total);
    $price.html('<span class="woocommerce-Price-currencySymbol">' + currency + '</span>&nbsp;' + price_total);
  }
  function _format_price2(price) {
    return new Intl.NumberFormat('de-CH', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(price);
  }
  ;
  if ($('body.single-product').length) {
    new PriceDisplay();
  }
});